import React from 'react';
import ComponentMemoizer from 'Global/Components/ComponentMemoizer/ComponentMemoizer';
import {
  Alert,
  LinearProgress,
  Stack,
} from '@mui/material';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import { useContext } from 'react';
import EditAddOrCancelForm from './EditAddOrCancelForm';
import EditInnerContenetAccordionContent from './EditInnerContenetAccordionContent';
import EditableAccordionContents from '../EditableAccordionContents/EditableAccordionContents';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { useAtom } from 'jotai';
import { surveyDisableEditAtom } from 'Global/shared/survey.disabel.edit.atom';

const EditGroupViewInnerContent = ({
  StateBank,
  control,
  errors,
  fields,
  getValues,
  reset,
  fieldArrayName,
  fetchedFrom,
  setValue,
  liftState,
  surveyDisable,
}) => {
  const GlobalConstants = useContext(GlobalContext);

  return (
    <React.Fragment>
      <ComponentMemoizer
        element={
          StateBank?.formId === StateBank?.GroupFormId ? (
            StateBank?.title?.length > 0 ? (
              <Stack spacing={'.5em'} width="100%">
                {StateBank?.FormView?.length === 0 ? (
                  <Alert dir="rtl" severity="warning">
                    {FindLangKey(
                      'general-public-warning-please-wait'
                    )}
                  </Alert>
                ) : (
                  StateBank?.FormView?.map((element) => (
                    <EditableAccordionContents
                      key={GlobalConstants.uuidV4()}
                      titleId={element.Id}
                      FormElement={
                        <EditInnerContenetAccordionContent
                          GroupId={element.Id}
                          fields={fields}
                          control={control}
                          errors={errors}
                          reset={reset}
                          fieldArrayName={fieldArrayName}
                          setValue={setValue}
                        />
                      }
                      title={ArabicToPersian(
                        element?.NameGroup
                      )}
                    />
                  ))
                )}
                <EditAddOrCancelForm
                  StateBank={StateBank}
                  getValues={getValues}
                  reset={reset}
                  fieldArrayName={fieldArrayName}
                  fetchedFrom={fetchedFrom}
                  liftState={liftState}
                  surveyDisable={surveyDisable}
                />
              </Stack>
            ) : (
              <></>
            )
          ) : (
            <LinearProgress />
          )
        }
        dependecies={[
          JSON.stringify(StateBank),
          JSON.stringify(fields),
          surveyDisable,
        ]}
      />
    </React.Fragment>
  );
};

export default EditGroupViewInnerContent;
